import type { FC } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components";

export interface EmailLoginFallbackSectionProps {
  className?: string;
  loginPath?: string;
}

export const EmailLoginFallbackSection: FC<EmailLoginFallbackSectionProps> = ({
  className = "mt-[40px]",
  loginPath = "/login-email",
}) => {
  const navigate = useNavigate();

  return (
    <div className={className}>
      <Button
        className="w-full"
        fill="outline"
        nativeType="button"
        size="large"
        onClick={() => navigate(loginPath)}
      >
        メールアドレスでログイン
      </Button>
      <p className="mt-2 text-center text-[14px] font-normal leading-[100%] text-[#6D6D78]">
        認証コードを受信できない場合のみ
      </p>
    </div>
  );
};
